import {
  ERROR_FETCH_ARCHIVE_REQUESTS,
  FETCH_ARCHIVE_REQUESTS,
} from '../actions/types';
const initialState = {
  loading: true,
  requests: [],
};
export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_ARCHIVE_REQUESTS:
      return { ...state, requests: payload, loading: false };
    case ERROR_FETCH_ARCHIVE_REQUESTS:
      return { ...state, requests: [], loading: true };
    default:
      return state;
  }
}
